import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { MapPin, Clock, Car, Train, Plane, Activity, Waves, Building2 } from 'lucide-react';

const LocationSection = () => {
  const proximityItems = [
    { icon: MapPin, label: "Cure thermale", distance: "200m", time: "2 min à pied" },
    { icon: Activity, label: "Golf", distance: "2km", time: "5 min en voiture" },
    { icon: Waves, label: "Gorges d'Héric", distance: "9km", time: "15 min en voiture" },
    { icon: Building2, label: "Arènes de Béziers", distance: "39km", time: "45 min en voiture" }
  ];

  return (
    <section id="emplacement" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <Badge variant="secondary" className="px-4 py-2 text-sm font-medium bg-emerald-100 text-emerald-800 border-emerald-200 mb-4">
              <MapPin className="h-4 w-4 mr-2" />
              Emplacement privilégié
            </Badge>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Un emplacement 
              <span className="bg-gradient-to-r from-emerald-600 to-emerald-600 bg-clip-text text-transparent"> exceptionnel</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Située au cœur de la station thermale, notre résidence vous offre un accès privilégié aux thermes et à toutes les commodités.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="bg-gradient-to-r from-emerald-50 to-emerald-50 p-8 rounded-2xl border border-emerald-100">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <MapPin className="h-6 w-6 text-emerald-600 mr-3" />
                  À 200m de la cure thermale
                </h3>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Profitez d'un accès ultra-rapide aux soins thermaux. En moins de 2 minutes à pied, vous êtes aux portes de vos soins et remise en forme.
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4">
                {proximityItems.map((item, index) => (
                  <Card key={index} className="hover:shadow-lg transition-shadow duration-300 border-gray-200 hover:border-emerald-200">
                    <CardContent className="p-6 text-center">
                      <item.icon className="h-8 w-8 text-emerald-600 mx-auto mb-3" />
                      <h4 className="font-semibold text-gray-900 mb-2">{item.label}</h4>
                      <p className="text-emerald-600 font-bold text-lg">{item.distance}</p>
                      <p className="text-gray-500 text-sm flex items-center justify-center mt-1">
                        <Clock className="h-3 w-3 mr-1" />
                        {item.time}
                      </p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>

            <div className="relative">
              <div className="bg-gradient-to-br from-emerald-100 to-emerald-100 p-8 rounded-2xl">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <h4 className="text-xl font-bold text-gray-900 mb-4">Avantages de l'emplacement</h4>
                  <ul className="space-y-3">
                    <li className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-emerald-600 rounded-full mt-2"></div>
                      <span className="text-gray-700">Accès direct aux soins thermaux (200m)</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-emerald-600 rounded-full mt-2"></div>
                      <span className="text-gray-700">Golf à 2km pour les amateurs</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-emerald-600 rounded-full mt-2"></div>
                      <span className="text-gray-700">Gorges d'Héric à 9km (nature préservée)</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-emerald-600 rounded-full mt-2"></div>
                      <span className="text-gray-700">Arènes de Béziers à 39km (culture)</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-emerald-600 rounded-full mt-2"></div>
                      <span className="text-gray-700">Plage à 40km (détente en bord de mer)</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-emerald-600 rounded-full mt-2"></div>
                      <span className="text-gray-700">Aéroport de Béziers proche</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;